"use client";

import { useAtomValue } from "jotai";
import { useEffect } from "react";

import {
  THEME_COOKIE_MAX_AGE,
  THEME_COOKIE_NAME,
  themeStyleAtom,
} from "@/atoms/preferences";

const THEME_CLASS_BY_STYLE = {
  legacy: "theme-legacy",
  new: "theme-new",
} as const;

export function AppThemeSync() {
  const themeStyle = useAtomValue(themeStyleAtom);

  const normalizedThemeStyle =
    themeStyle === "legacy" || themeStyle === "new" ? themeStyle : "new";

  useEffect(() => {
    if (typeof document === "undefined") return;

    const html = document.documentElement;
    const body = document.body;
    const nextClass =
      THEME_CLASS_BY_STYLE[normalizedThemeStyle] ?? THEME_CLASS_BY_STYLE.new;
    const themeClassSet = new Set(Object.values(THEME_CLASS_BY_STYLE));

    themeClassSet.forEach((className) => {
      if (className !== nextClass) {
        html.classList.remove(className);
        if (body) {
          body.classList.remove(className);
        }
      }
    });

    html.classList.add(nextClass);
    if (body) {
      body.classList.add(nextClass);
    }
    html.setAttribute("data-theme", normalizedThemeStyle);
    if (body) {
      body.setAttribute("data-theme", normalizedThemeStyle);
    }

    // Sync to cookie so the server can render the correct theme on next load
    document.cookie = `${THEME_COOKIE_NAME}=${normalizedThemeStyle}; path=/; max-age=${THEME_COOKIE_MAX_AGE}; SameSite=Lax`;
  }, [normalizedThemeStyle]);

  return null;
}
